import axios from "../axios";
import { truncate } from "lodash";

export class User {
  firstName;
  lastName;
  email;
  username;
  id;
}

/**
 * A display name for the user.
 *
 * See also: getUserById()
 * @param {User} user
 * @returns {string}
 */
export function getUserName(user) {
  if (!user) return null;
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  if (user.firstName) {
    return user.firstName;
  }
  return user.email || user.username || truncate(user.id, 12);
}

const api = {
  getUserById(auth0UserId) {
    // console.log('auth0userID => ',auth0UserId);
    /* 
      Reason for using encodeURIComponent - 
      Firefox is stricter about illegal URL characters in the path. | is not allowed in a path segment per RFC 3986, 
      so Tomcat/Spring returns HTTP 400 – Bad Request. Chrome sometimes tolerates or silently normalizes this; Firefox doesn’t.
      Encoding it will work for both firefox as well as chrome.
    */
    const encodedUserID = encodeURIComponent(auth0UserId);  
    return axios.get(`/users/${encodedUserID}`).then(({ data }) => data);
    // return axios.get(`/users/${auth0UserId}`).then(({ data }) => data);
  },

  getUsers(paramsString) {
    return axios.get(`/administration/organization/users?${paramsString || ""}`).then(({ data }) => data);
  },
  getUsersStatuses(params, accessToken) {
    const config = {
      params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/administration/users/statuses`, config).then(({ data }) => data);
  },
  /** from our database Warning: manually-managedoverlap with Auth0  */
  getUsersRoles(params, accessToken) {
    const config = {
      params,
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.get(`/administration/users/roles`, config).then(({ data }) => data);
  },
  createUser(data, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.post("/administration/organization/users", data, headers).then(({ data }) => data);
  },
  addExternalUser(data, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.put("/administration/organization/users/external", data, headers).then(({ data }) => data);
  },
  updateUser({ id, data }, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.put(`/administration/organization/users/${id}`, data, headers).then(({ data }) => data);
  },
  resendInvitation(id, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios.post(`/administration/organization/users/${id}/invitation`, {}, headers).then(({ data }) => data);
  },
  activateUser(id, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios
      .patch(`/administration/organization/users/${id}/status`, { status: "ACTIVE" }, headers)
      .then(({ data }) => data);
  },
  deactivateUser(id, accessToken) {
    const headers = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };
    return axios
      .patch(`/administration/organization/users/${id}/status`, { status: "DEACTIVATED" }, headers)
      .then(({ data }) => data);
  },
};

export default api;
